import { Checkbox, FormHelperText, InputLabel, ListItemText, MenuItem, Select, Typography } from '@mui/material';
import styles from './styles';
import { CustomSelectProps, Item } from './types';

const getSelectedText = (items: Item[], selected: number[]) => {
    return selected
        ? selected.reduce((acc, curr) => `${acc}${items.find((s) => curr === Number(s.value))?.name}, `, '')
        : '';
};

const CustomSelect = ({
    id,
    label,
    name,
    items,
    handleOnchange,
    value,
    errorMessage = '',
    multiple = false,
    handleCheckItem,
    customStyles = {},
    ...props
}: CustomSelectProps) => {
    return (
        <>
            <InputLabel
                id={`select_label_${name}`}
                htmlFor={name}
                sx={props.error ? { ...styles.label, color: '#ED0000' } : styles.label}
            >
                {label}
            </InputLabel>
            <Select
                id={`select-${id}`}
                value={value}
                {...props}
                name={name}
                sx={[styles.select, customStyles]}
                displayEmpty
                variant="outlined"
                fullWidth
                onChange={(event) => {
                    handleOnchange(event);
                    if (
                        multiple &&
                        value &&
                        handleCheckItem &&
                        Array.isArray(event.target.value) &&
                        Array.isArray(value)
                    ) {
                        const checked = !(
                            value.find(
                                (v) =>
                                    v ===
                                    (Array.isArray(event.target.value) &&
                                        event.target.value[event.target.value.length - 1]),
                            ) || event.target.value.length === 0
                        );
                        handleCheckItem(
                            checked,
                            checked ? event.target.value[event.target.value.length - 1] : value[value.length - 1],
                        );
                    }
                }}
                multiple={multiple}
                inputProps={{ 'data-testid': id, id }}
                renderValue={(selected: any) => {
                    if (!selected || selected.length === 0)
                        return (
                            <Typography id="drowdown_title" sx={styles.placeholder} component="span">
                                Select...
                            </Typography>
                        );
                    if (typeof selected === 'object') {
                        return getSelectedText(items, selected);
                    }
                    return items.map((item) => {
                        if (typeof value === 'string') {
                            return item.value === selected && item.name;
                        }
                        return Number(item.value) === Number(selected) && item.name;
                    });
                }}
            >
                {items.map((item) => (
                    <MenuItem value={item.value} sx={styles.item} key={item.value} id={`menu_item_${item.value}`}>
                        {multiple ? (
                            <>
                                <Checkbox
                                    checked={Array.isArray(value) ? value && value.indexOf(item.value) > -1 : false}
                                />
                                <ListItemText primary={item.name} />
                            </>
                        ) : (
                            item.name
                        )}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText id="error_text" sx={styles.error_message}>
                {errorMessage}
            </FormHelperText>
        </>
    );
};

export default CustomSelect;
